<lib-demande-resiliation [maxFileSelected]="MAX_FILE_SELECT" [fileMaxSize]="FILE_MAX_SIZE" [fileAccept]="FILE_ACCEPT_TYPE" [EMAIL_PATTERN]="EMAIL_PATTERN" [configuration]="configuration" 
[fileNamePattern]="fileNamePattern"></lib-demande-resiliation>
